import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Wrapper = styled.div`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 6)};
  border: 1px solid ${getThemeColor('bluegrey.90')};
  ${({ theme }) => theme.getFluidSpacing('padding', 'equal', 4)};
  border-radius: ${({ theme }) => theme.borderRadiuses['normal.1']}rem;
`;

export const NoSizesTitle = styled(Typography).attrs({
  variant: 'body2',
  customAs: 'h6',
})`
  margin: 0;
  color: ${getThemeColor('bluegrey.60')};
  text-align: center;
`;

export const SizesListTitle = styled(Typography).attrs({
  variant: 'body3',
  customAs: 'h6',
})`
  color: ${getThemeColor('bluegrey.60')};
`;

export const SizesList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0.7rem 0 0;
  padding: 0;
  list-style: none;
  gap: 0.8rem;
`;

export const Size = styled.li`
  ${({ theme }) => theme.getFluidFont('body4')}
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 100%;
  border-radius: ${({ theme }) => `${theme.borderRadiuses.pill}rem`};
  padding: 0.3rem 0.8rem;
  background-color: ${getThemeColor('bluegrey.95')};
  color: ${getThemeColor('bluegrey.40')};
  text-align: center;
`;
